import { useRef, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { FormControl, FormHelperText, InputBase, InputLabel, InputBaseProps, OutlinedInput } from '@mui/material';
// import { InputBase } from '@mui/material/TextField';
import { useField, useFormikContext } from 'formik';
import { values } from 'lodash';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';

// export const BootstrapInput = styled(InputBase)(({ theme }) => ({
//   'label + &': {
//     marginTop: theme.spacing(4),
//   },
//   '&.MuiInputBase-root': {
//     borderRadius: 4,
//     position: 'relative',
//     backgroundColor: theme.palette.common.white,
//     border: '1px solid #DDEAF3',
//     // transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
//     '&:hover': {
//       borderColor: theme.palette.primary.main,
//     },
//     '.MuiInputBase-input': {
//       margin: '5px 12px',
//       borderRadius: 4,
//       // '&:focus': {
//       //   boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
//       //   borderColor: theme.palette.primary.main,
//       // },
//     },
//     '.MuiInputAdornment-root': {
//       marginLeft: '12px',
//       marginRight: 0,
//       paddingRight: '12px',
//       borderRight: '1px solid #DDEAF3',
//       height: '45px',
//       '.MuiCardMedia-root': {
//         width: 24,
//       },
//     },
//     '& ::placeholder': {
//       textTransform: 'none',
//       fontSize: '0.9rem',
//     },
//     'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
//       WebkitAppearance: 'none',
//       margin: 0,
//     },
//     'input[type=number]': {
//       MozAppearance: 'textfield',
//     },
//   },
// }));

export const BootstrapOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  '&.MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: "10px",
      backgroundColor: `${theme.palette.common.white}0D`,
      border: `0.5px solid ${theme.palette.text.secondary}80`,
    },
    // Highlight the field's own border on focus (thrive brand color) instead of removing it
    '&.Mui-focused fieldset': {
      border: `2px solid ${theme.palette.primary[500]} !important`,
    },
    '.MuiInputBase-input': {
      ...theme.typography.body_500,
      color: theme.palette.text.primary,
      padding: "15px"
    },
  },
}));

export default function MFTextField({
  name,
  label,
  placeholder,
  defaultValue,
  readonly,
  inputProps,
  margin,
  startAdornment,
  onChange,
  sx,
  trimOnBlur = true,
  displayCharecterCounter = '',
  applyMarginBottom = true,
  formatCurrency = false,
  onPaste = () => { return; },
  formatCurrencyLocaleOptions = {},
  ...props
}: InputBaseProps & {
  name: string;
  label?: string;
  margin?: 'dense' | 'none' | undefined;
  placeholder: string;
  defaultValue?: string;
  readonly?: boolean;
  startAdornment?: JSX.Element;
  trimOnBlur?: boolean;
  displayCharecterCounter?: string;
  applyMarginBottom?: boolean;
  formatCurrency?: boolean;
  onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void;
  formatCurrencyLocaleOptions?: Intl.NumberFormatOptions;
}): JSX.Element {
  const theme = useTheme()
  const { locale = "en-IN" } = useSelector((store: RootStateType) => store.currencyInfo);

  const id = `${name}-input`;
  const inputRef = useRef<HTMLInputElement>(null);
  const [field, meta, helpers] = useField(name);
  onChange = onChange || field.onChange;
  const { setFieldValue } = useFormikContext();
  const { setTouched } = helpers;
  const errorText = meta.error && meta.touched ? meta.error : '';

  const formatCurrencyValue = () => {
    const { value } = field;
    const modifiedValue = value?.trim() ?? ""

    if (modifiedValue?.length && !Number.isNaN(Number(modifiedValue))) {
      const formattedValue = Number(modifiedValue)?.toLocaleString(locale, formatCurrencyLocaleOptions);

      setFieldValue(name, formattedValue);
    } else {
      setFieldValue(name, modifiedValue);
    }
  };

  // eslint-disable-next-line
  const onBlur = (e: React.ChangeEvent<any>): void => {
    const { target: fieldTarget } = e;
    const { value } = fieldTarget;

    setTimeout(() => {
      if (formatCurrency) {
        formatCurrencyValue()
      } else {
        trimOnBlur &&
          setFieldValue(
            name,
            value && typeof value === 'string'
              ? !meta.initialValue && value.trim() === ''
                ? meta.initialValue
                : value.trim()
              : value
          );
      }
      setTouched(true, true);
    }, 0);
  };

  const onFocus = (e: React.ChangeEvent<any>): void => {
    if (formatCurrency) {
      const { target: fieldTarget } = e;
      const { value } = fieldTarget;

      setFieldValue(name, `${value}`?.replaceAll(',', ''));
    }
  }
  // useEffect(() => {
  //   inputRef.current?.addEventListener('wheel', (e) => e.preventDefault());
  // }, []);

  return (
    // <FormControl
    //   variant="outlined"
    //   fullWidth
    //   sx={{ mt: { xs: 1, md: 2 }, mb: applyMarginBottom ? { xs: 1, md: 2 } : 1, ...sx }}>
    //   {label && (
    //     <InputLabel
    //       shrink
    //       htmlFor={id}
    //       sx={{
    //         transform: 'unset',
    //         fontSize: 14,
    //         fontWeight: 500,
    //         color: 'rgba(0,0,0,0.7)',
    //       }}>  
    //       {label}
    //     </InputLabel>
    //   )}
    //   <BootstrapInput
    //     defaultValue={defaultValue}
    //     placeholder={placeholder}
    //     id={id}
    //     startAdornment={startAdornment}
    //     {...field}
    //     onBlur={onBlur}
    //     margin={margin}
    //     disabled={readonly || false}
    //     inputProps={inputProps}
    //     {...props}
    //     onChange={onChange}
    //     ref={inputRef}
    //     sx={{
    //       '& .Mui-disabled': {
    //         cursor: !props.disabled ? 'text' : 'not-allowed !important',
    //         pointerEvents: 'all',
    //       },
    //       ...sx,
    //     }}
    //   />
    //   <Box
    //     sx={{
    //       display: 'flex',
    //       justifyContent: 'space-between',
    //       alignItems: 'center',
    //       flexDirection: errorText ? 'row' : 'row-reverse',
    //     }}>
    //     {errorText && (
    //       <FormHelperText error sx={{ marginLeft: 'unset' }}>
    //         {errorText}
    //       </FormHelperText>
    //     )}
    //     {displayCharecterCounter && (
    //       <FormHelperText sx={{ marginLeft: 'unset' }}>
    //         {`${field.value.toString().length} / ${displayCharecterCounter}`}
    //       </FormHelperText>
    //     )}
    //   </Box>
    // </FormControl>

    <FormControl
      variant="outlined"
      fullWidth
      sx={{ mt: { xs: 1, md: 2 }, mb: applyMarginBottom ? { xs: 1, md: 2 } : 1, ...sx }}
    >
      <InputLabel
        htmlFor={id}
        sx={{
          color: props.disabled ? `${theme.palette.text.secondary}4D` : "text.secondary",
          ...(theme.typography.body_500)
        }}
      >{label?.split('*')[0]}
        {label?.includes('*') && (
          <Box component="span" sx={{ color: props.disabled ? `${theme.palette.text.secondary}4D` : theme.palette.error[500] }}> *</Box>
        )}
      </InputLabel>
      <BootstrapOutlinedInput
        defaultValue={defaultValue}
        label={label}
        id={id}
        startAdornment={startAdornment}
        {...field}
        onBlur={onBlur}
        onFocus={onFocus}
        onPaste={onPaste}
        margin={margin}
        disabled={readonly || false}
        inputProps={{
          ...inputProps,
          'aria-invalid': !!errorText,
          'aria-describedby': errorText ? `${id}-error` : displayCharecterCounter ? `${id}-counter` : undefined,
          'aria-required': label?.includes('*') ? true : undefined,
        }}
        {...props}
        onChange={onChange}
        ref={inputRef}
        sx={{
          '& .Mui-disabled': {
            cursor: !props.disabled ? 'text' : 'not-allowed !important',
            pointerEvents: 'all',
          },
          ...sx,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: errorText ? 'row' : 'row-reverse',
        }}>
        {errorText && (
          <FormHelperText error sx={{ marginLeft: 'unset' }} id={`${id}-error`} role="alert" aria-live="polite">
            {errorText}
          </FormHelperText>
        )}
        {displayCharecterCounter && (
          <FormHelperText sx={{ marginLeft: 'unset' }} id={`${id}-counter`} aria-live="polite">
            {`${field.value.toString().length} / ${displayCharecterCounter}`}
          </FormHelperText>
        )}
      </Box>
    </FormControl >
  );
}
